import { render, staticRenderFns } from "./IWant.vue?vue&type=template&id=bd35b37c&scoped=true&"
import script from "./IWant.vue?vue&type=script&lang=js&"
export * from "./IWant.vue?vue&type=script&lang=js&"
import style0 from "./IWant.vue?vue&type=style&index=0&id=bd35b37c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd35b37c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VCard,VIcon,VProgressCircular,VProgressLinear,VSkeletonLoader})
